import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

const steps = [
  { number: 1, text: "Open the App" },
  { number: 2, text: "Choose Report or SOS" },
  { number: 3, text: "Take a photo/video and select a category" },
  { number: 4, text: "Add a brief explanation" },
  { number: 5, text: "The report is geo-tagged and sent instantly" },
  { number: 6, text: "Follow progress and receive rewards after approval" },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="py-5 bg-light text-dark">
      <h2 className="text-center fw-bold mb-5">How it Works</h2>

      <div className="vector-img-bg col-lg-9 mx-auto">
        <div className="vector-bg-overlay">
          <div className="container">
            {/* Grid */}
            <div className="row g-4 col-lg-8 mx-auto justify-content-center">
              {steps.map((step) => (
                <div className="col-6 col-sm-6 col-lg-4" key={step.number}>
                  <div className="step-card">
                    <h3>{step.number}</h3>
                    <p>{step.text}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Store buttons */}
            <div className="d-flex justify-content-center gap-3 mt-5">
              <a href="https://play.google.com/">
                <img src={googleImg} alt="Google Play" height="45" />
              </a>
              <a href="https://play.google.com/">
                <img src={appStoreImg} alt="App Store" height="45" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
